module.exports = __webpack_public_path__ + "img/vt-at.4fc02bd4.svg";